export default "__VITE_ASSET__Bfdr0c3O__"